"use strict";

(() => {
    const originalGallery = document.querySelector('.product__starapps');
    const swiperContainer = document.querySelector('.bs-product-gallery__swiper');
    const thumbnailContainer = document.querySelector('.bs-product-gallery__thumbnail-swiper');

    if (!originalGallery || !swiperContainer || !thumbnailContainer) return;

    const config = { childList: true, subtree: true };

    const thumbsSwiper = new Swiper(thumbnailContainer, {
        spaceBetween: 16,
        slidesPerView: 7.8
    });

    const mainSwiper = new Swiper(swiperContainer, {
        navigation: {
            nextEl: ".bs-product-gallery__swiper .swiper-button-next",
            prevEl: ".bs-product-gallery__swiper .swiper-button-prev",
        },
        thumbs: { swiper: thumbsSwiper },
        pagination: { el: ".bs-product-gallery__swiper .swiper-pagination" },
    });

    const updateGallery = () => {
        const starAppsGallery = document.querySelector('product-gallery.starapps');
        if (!starAppsGallery) return;

        const images = starAppsGallery.querySelectorAll('.product-gallery__media img');
        if (!images.length) return;

        thumbsSwiper.removeAllSlides();
        mainSwiper.removeAllSlides();

        images.forEach((img) => {
            const slideHTML = `<div class="swiper-slide">${img.outerHTML}</div>`;
            thumbsSwiper.appendSlide(slideHTML);
            mainSwiper.appendSlide(slideHTML);
        });
    };

    const observer = new MutationObserver(updateGallery);
    observer.observe(originalGallery, config);
})();
